/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
    display: flex
}

ul {
    margin: 0px;
    display: inline-flex;
    block-size: 100%;
    align-items: center;
    padding: 0px
}

:host([layout=vertical]) ul {
    display: flex;
    inline-size: 100%;
    flex-direction: column
}

:host([hidden]) {
    display: none
}

[hidden] {
    display: none
}